export default function AlignRight() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 2H6C5.44688 2 5 1.55219 5 1C5 0.447812 5.44688 0 6 0H13C13.5531 0 14 0.447812 14 1C14 1.55219 13.5531 2 13 2ZM13 10H6C5.44688 10 5 9.55313 5 9C5 8.44687 5.44688 8 6 8H13C13.5531 8 14 8.44687 14 9C14 9.55313 13.5531 10 13 10ZM0 5C0 4.44688 0.447812 4 1 4H13C13.5531 4 14 4.44688 14 5C14 5.55312 13.5531 6 13 6H1C0.447812 6 0 5.55312 0 5ZM13 14H1C0.447812 14 0 13.5531 0 13C0 12.4469 0.447812 12 1 12H13C13.5531 12 14 12.4469 14 13C14 13.5531 13.5531 14 13 14Z" fill="currentColor" />
    </svg>
  )
}
